import { ValueOf } from './util';

export const ETransactionCodeType = {
  CPM: 'CPM',
  MPM: 'MPM',
  SMART_CODE: 'Smart Code',
} as const;

export type TransactionCodeTypeKey = keyof typeof ETransactionCodeType;
export type TransactionCodeTypeValue = ValueOf<typeof ETransactionCodeType>;

export const transactionCodeTypeKeys = Object.keys(ETransactionCodeType) as TransactionCodeTypeKey[];

/** v-select用items */
export const transactionCodeTypeItems = transactionCodeTypeKeys
  .map((key) => ({
    title: ETransactionCodeType[key],
    value: key,
  }));
